import React, { useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { checkHashStore } from '../../store/checkHashStore';
import CloseFairness from './closeFairness';
import FairnessInfo from './fairnessInfo';
import LastRoundData from './lastRoundData';
import { popupStore } from '../../store/popupStore';
import { TAB_INDEX_FOR_FAIRNESS } from '../../core/constants/gameConstants';
import FairnessTabRowInfo from './fairnessTabRowInfo';

import FairnessInputsGroup from './fairnessInputsGroup';
import TicketWrapper from '../ticketWrapper';
import useTranslation from '../../hooks/useTranslation';

const Fairness = observer(() => {
  const { close } = popupStore;
  const { lastRoundResult } = checkHashStore;
  const [activeTabIndex, setActiveTabIndex] = useState(TAB_INDEX_FOR_FAIRNESS.Fairness);
  const t = useTranslation();

  const tabsInfo = useMemo(() => {
    return {
      [TAB_INDEX_FOR_FAIRNESS.Fairness]: FairnessInputsGroup,
      [TAB_INDEX_FOR_FAIRNESS.History]: TicketWrapper,
    };
  }, []);

  const ActiveTabInfo = useMemo(() => {
    return tabsInfo[activeTabIndex];
  }, [activeTabIndex, tabsInfo]);

  const handleClose = useCallback(() => {
    close();
  }, [close]);

  return (
    <div className='fairness-container'>
      <div className='cpt-pp-content for-test-Provably-Faireness'>
        <div className='fairness-top-container'>
          <div className='fairness-title-block'>
            <CloseFairness handleClose={handleClose} />
            {lastRoundResult ? (
              <FairnessInfo roundId={lastRoundResult.id} time={lastRoundResult.time} t={t} />
            ) : null}
          </div>

          {lastRoundResult ? <LastRoundData resultNumber={lastRoundResult.resultNumbers} /> : null}
          <div className='fairness-tab-wrapper'>
            <FairnessTabRowInfo
              activeTabIndex={activeTabIndex}
              setActiveTabIndex={setActiveTabIndex}
            />
          </div>
        </div>
        <div className='cpt-scroll-holder'>
          <div className='cpt-scrollable-container fairnes-tab-inner'>
            <ActiveTabInfo
              t={t}
              isBetsClosed
              isFromFairness
              isShowBetInfo={false}
              tickets={lastRoundResult?.tickets || []}
              winNumbersForTickets={lastRoundResult?.resultNumbers || []}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
export default Fairness;
